import { render, staticRenderFns } from "./BySlider.vue?vue&type=template&id=5369fc4d&scoped=true"
import script from "./BySlider.vue?vue&type=script&lang=js"
export * from "./BySlider.vue?vue&type=script&lang=js"
import style0 from "./BySlider.vue?vue&type=style&index=0&id=5369fc4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5369fc4d",
  null
  
)

export default component.exports